var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldVideoRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.84 15.5c-.81-.93-2.01-1.5-3.34-1.5-1.26 0-2.41.52-3.23 1.36a4.5 4.5 0 0 0-.62 5.46c.23.38.52.73.86 1.02.05.05.1.09.16.14h.01A4.35 4.35 0 0 0 18.5 23c1.64 0 3.07-.88 3.85-2.18.23-.39.41-.82.52-1.27a4.417 4.417 0 0 0-.89-3.88c-.04-.06-.09-.12-.14-.17zm-2.14 4.93c-.19 0-.38-.07-.53-.22l-.66-.66-.69.69c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.69-.69-.66-.66a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.66.66.63-.63c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.63.63.66.66c.3.29.3.76 0 1.06-.15.15-.34.22-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73 2.5c0-.28-.22-.5-.5-.5H9.77c-.28 0-.5.22-.5.5v3.36c0 .28.22.5.5.5h4.46c.28 0 .5-.22.5-.5V2.5zM2.289 5.7c-.1.33.14.66.48.66h4.5c.28 0 .5-.22.5-.5V2.52a.5.5 0 0 0-.52-.5c-2.56.16-4.31 1.48-4.96 3.68zM21.71 5.689c.1.33-.14.66-.48.66h-4.5c-.28 0-.5-.22-.5-.5v-3.34a.5.5 0 0 1 .52-.5c2.56.16 4.31 1.48 4.96 3.68zM22 12.74c0 .37-.39.61-.72.44a6.013 6.013 0 0 0-7.08 1.13 5.94 5.94 0 0 0-1.7 4.19c0 .81.32 1.85.72 2.72.16.35-.08.78-.47.78H7.81C4.6 22 2 19.4 2 16.19V8.36c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v4.38z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldVideoRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-video-remove.2d1d00576dc5ae20aef28c4666045a64.svg";
export { ForwardRef as ReactComponent };